import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class BacklogRoute extends Route {
  @service router;

  beforeModel(/* transition */) {
    this.router.transitionTo('backlog.initiatives'); // Implicitly aborts the on-going transition.
  }
}
